import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";

import CloseIcon from "../closeIcon";

const StyledTopbar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  height: 3rem;
  border-bottom: 1px solid ${(props) => props.theme.color.lightGrey};
  ${(props) => props.theme.shadow}
  ${(props) => props.theme.responsive.mobile} {
    position: relative;
    box-shadow: none;
  }
`;

const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 1.2rem;
  padding-bottom: 0.2rem;
`;

const StyledSubtitle = styled.div`
  flex: 1;
  font-size: 0.6rem;
  margin-left: 12px;
  color: ${(props) => props.theme.color.grey};
`;

const Topbar = ({ bagFrames, handlerClosePopup, ...props }) => {
  const intl = useIntl();
  return (
    <StyledTopbar>
      <StyledTitle>
        {intl.formatMessage({
          id: `buyPopup.topbar.cart`,
        })}
      </StyledTitle>
      <StyledSubtitle>
        {bagFrames.length}{" "}
        {intl.formatMessage({
          id: `buyPopup.topbar.item`,
        })}
        {bagFrames.length !== 1 && "s"}
      </StyledSubtitle>
      <CloseIcon size={0.6} handlerClick={() => handlerClosePopup()} />
    </StyledTopbar>
  );
};

export default Topbar;
